<template>
  <div class="manage_page fillcontain">
    <div class="sidebar-container">
      <el-menu
        class="el-menu-vertical-demo"
        :default-active="defaultActive"
        @select="selectItems"
        style="min-height: 100%;"
        background-color="#001529"
        text-color="#fff"
        theme="dark"
        :default-openeds="openeds"
        :collapse="isCollapse"
        :unique-opened="true"
      >
        <div class="logo" v-if="!isCollapse">小城达人</div>
        <el-menu-item index="/workBench">
          <i class="el-icon-menu"></i>
          <span slot="title">工作台</span>
        </el-menu-item>
        <template v-for="item in navlist">
          <el-submenu :index="item.id" :key="item.id" v-if="item.page.length>0">
            <template slot="title">
              <i class="el-icon-document" v-if="item.title == '管理'"></i>
              <i class="el-icon-plus" v-if="item.title == '设置'"></i>
              <i class="el-icon-user-solid" v-if="item.title == '用户角色'"></i>
              <i class="el-icon-star-on" v-if="item.title == '流水统计'"></i>
              <span slot="title">{{item.title}}</span>
            </template>
            <el-menu-item
              :index="value.path"
              v-for="(value,itemindex) in item.page"
              :key="itemindex"
            >{{value.title}}</el-menu-item>
            <!-- <el-menu-item index="/darenInfo">达人管理</el-menu-item>
            <el-menu-item index="/orderInfo">订单管理</el-menu-item>-->
            <!-- <el-menu-item index="/peixunInfo">培训管理</el-menu-item> -->
            <!-- <el-menu-item index="/joinCompany">招商加盟管理</el-menu-item> -->
          </el-submenu>
        </template>
        <!-- <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-plus"></i>
            <span slot="title">设置</span>
          </template>
          <el-menu-item index="/homeShowData">首页展示</el-menu-item>
          <el-menu-item index="/h5Setimg">H5页面</el-menu-item>
          <el-menu-item index="/orderSetting">订单模块</el-menu-item>
          <el-menu-item index="/companyPay">企业付费</el-menu-item>
          <el-menu-item index="/darenModule">达人模块</el-menu-item>
          <el-menu-item index="/inviteReward">邀请有奖</el-menu-item>
          <el-menu-item index="/contactKefu">客服信息</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-star-on"></i>
            <span slot="title">流水统计</span>
          </template>
          <el-menu-item index="/flowStatistics">流水明细</el-menu-item>
        </el-submenu>-->
      </el-menu>
    </div>
    <div class="main-container" :class="isCollapse ? 'main-container-left':''">
      <head-top
        @exit="exitLogin()"
        @modifyPassword="modifyPassword()"
        @hideNav="hideNavBar()"
        :name="username"
        :info="system"
      ></head-top>
      <keep-alive exclude="companyInfo,darenInfo,orderInfo,peixunDetail,kefuInfo">
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { systemInfo } from "@/config/api.js";
import headTop from "@/components/headTop";
export default {
  data() {
    return {
      defaultActive: "/companyInfo",
      openeds: ["1", "2"],
      isCollapse: false,
      username: "",
      navlist: [
        // {
        //   id: "1",
        //   title: "管理",
        //   icon: "el-icon-document",
        //   children: [
        //     {
        //       itemtitle: "企业管理",
        //       path: "/companyInfo"
        //     },
        //     {
        //       itemtitle: "达人管理",
        //       path: "/darenInfo"
        //     },
        //     {
        //       itemtitle: "订单管理",
        //       path: "/orderInfo"
        //     },
        //     {
        //       itemtitle: "招商加盟管理",
        //       path: "/joinCompany"
        //     }
        //   ]
        // },
        // {
        //   id: "2",
        //   title: "设置",
        //   icon: "el-icon-plus",
        //   children: [
        //     {
        //       itemtitle: "首页展示",
        //       path: "/homeShowData"
        //     },
        //     {
        //       itemtitle: "H5页面",
        //       path: "/h5Setimg"
        //     },
        //     {
        //       itemtitle: "订单模块",
        //       path: "/orderSetting"
        //     },
        //     {
        //       itemtitle: "企业付费",
        //       path: "/companyPay"
        //     },
        //     {
        //       itemtitle: "达人模块",
        //       path: "/darenModule"
        //     },
        //     {
        //       itemtitle: "邀请有奖",
        //       path: "/inviteReward"
        //     },
        //     {
        //       itemtitle: "客服信息",
        //       path: "/contactKefu"
        //     }
        //   ]
        // },
        // {
        //   id: "3",
        //   title: "用户角色",
        //   icon: "el-icon-user-solid",
        //   children: [
        //     {
        //       itemtitle: "角色权限",
        //       path: "/role"
        //     },
        //     {
        //       itemtitle: "用户管理",
        //       path: "/user"
        //     },
        //     {
        //       itemtitle: "操作日志",
        //       path: "/daily"
        //     }
        //   ]
        // },
        // {
        //   id: "4",
        //   title: "流水统计",
        //   icon: "el-icon-star-on",
        //   children: [
        //     {
        //       itemtitle: "流水明细",
        //       path: "/flowStatistics"
        //     }
        //   ]
        // }
      ],
      system: {
        
      }
    };
  },
  components: {
    headTop
  },
  created() {
    this.navlist = JSON.parse(localStorage.getItem("userNav"));//获取左侧菜单列表
    this.username = localStorage.getItem("username");//获取账号用户名
  },
  mounted() {
    // if (this.$route.path == "/darenInfoDetail") {
    //   this.defaultActive = "/orderInfo";
    //   return;
    // }
    this.defaultActive = this.$route.path;
    this.getSystemInfo()
  },

  methods: {
    getSystemInfo() {
      //获取系统公告
      this.$post(systemInfo, {})
        .then(res => {
          console.log("success", res);
          if(res.data){
            this.system = res.data;
          }
          
        })
        .catch(err => {
          console.log("err", err);
        });
    },
    selectItems(index) {
      //导航栏跳转
      console.log(index);
      this.defaultActive = index;
      this.$router.push(index);
    },
    exitLogin() {
      //退出登录
      console.log("exit=======");
      this.$confirm("是否退出当前账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "成功退出!"
          });
          localStorage.removeItem("xctoken");
          localStorage.removeItem("uid");
          this.$router.push("/");
        })
        .catch(() => {});
    },
    hideNavBar() {
      //隐藏导航栏
      this.isCollapse = !this.isCollapse;
    },
    modifyPassword() {
      //修改密码
      this.$router.push("/modifyPassword");
    }
  },
  watch: {
    $route(to, from) {
      //监听路由变化
      console.log("path", to.path);
      // this.defaultActive = this.$route.path;
    }
  }
};
</script>

<style scoped>
.fillcontain {
  position: relative;
  height: 100%;
  width: 100%;
}
.sidebar-container {
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  overflow-y: scroll;
  /* overflow: hidden; */
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 100%;
}
.logo {
  width: 100%;
  height: 55px;
  text-align: center;
  line-height: 55px;
  background: #00284d;
  color: #fff;
  font-size: 20px;
}
.main-container {
  /* float: left; */
  min-height: 100%;
  -webkit-transition: margin-left 0.28s;
  transition: margin-left 0.28s;
  margin-left: 200px;
  position: relative;
  background: rgb(240, 242, 245);
}
.main-container-left {
  margin-left: 64px;
}
.el-submenu__title {
  color: #bfcbd9;
}
.el-menu {
  border-right: none;
}
.el-submenu .el-menu-item {
  min-width: 100%;
  /* color: rgba(255, 255, 255,.7)!important; */
}
.el-submenu__title i {
  color: #fff;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
  opacity: 0;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/manage.vue